import React from 'react';

import imgLogo from 'assets/images/header/logo-header.png';





const HeaderSecondary = () => {

    return (
        
        <header >
            <nav className="navbar navbar-expand-lg h-100">
                <div className="container menu h-100">
                    <div className="navbar-brand">
                        <div className="row h-100">
                            <div className="col-12 my-auto">
                                <a >
                                    <img src={imgLogo} alt="Metro"/>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </header>
       
    )
}

export default HeaderSecondary;